module.exports = __webpack_public_path__ + "static/media/mo.65be45a6.svg";